// extracted by mini-css-extract-plugin
module.exports = {"categories__wrapper":"bn_fR","categories__list":"bn_fS"};